export default {
  namespaced: true,
  state: {
    // Permisos para secciones del sistema
    isClientes: false,
    isUsuarios: false,
    isPerfil: false,
    isRoles: false,
    isProveedores: false,
    isPuertos: false,
    isDestinos: false,
    isContenedores: false,
    isPallet: false,
    isCondiciones: false,
    isNaves: false,
    isNavieras: false,
    isProductos: false,
    isLimitePlanificaciones: false,
    isTemporadas: false,
    isEmbarcador: false,
  },
  mutations: {
    setIsClientes(state, payload) {
      state.isClientes = payload;
    },
    setIsUsuarios(state, payload) {
      state.isUsuarios = payload;
    },
    setIsPerfil(state, payload) {
      state.isPerfil = payload;
    },
    setIsRoles(state, payload) {
      state.isRoles = payload;
    },
    setIsProveedores(state, payload) {
      state.isProveedores = payload;
    },
    setIsPuertos(state, payload) {
      state.isPuertos = payload;
    },
    setIsDestinos(state, payload) {
      state.isDestinos = payload;
    },
    setIsContenedores(state, payload) {
      state.isContenedores = payload;
    },
    setIsPallet(state, payload) {
      state.isPallet = payload;
    },
    setIsCondiciones(state, payload) {
      state.isCondiciones = payload;
    },
    setIsNaves(state, payload) {
      state.isNaves = payload;
    },
    setIsNavieras(state, payload) {
      state.isNavieras = payload;
    },
    setIsProductos(state, payload) {
      state.isProductos = payload;
    },
    setIsLimitePlanificaciones(state, payload) {
      state.isLimitePlanificaciones = payload;
    },
    setIsTemporadas(state, payload) {
      state.isTemporadas = payload;
    },
    setIsEmbarcador(state, payload) {
      state.isEmbarcador = payload;
    },

    //
  },
  actions: {
    AccionCambiarIsClientes({ commit }, data) {
      commit("setIsClientes", data);
    },
    AccionCambiarIsUsuarios({ commit }, data) {
      commit("setIsUsuarios", data);
    },
    AccionCambiarIsPerfil({ commit }, data) {
      commit("setIsPerfil", data);
    },
    AccionCambiarIsRoles({ commit }, data) {
      commit("setIsRoles", data);
    },
    AccionCambiarIsProveedores({ commit }, data) {
      commit("setIsProveedores", data);
    },
    AccionCambiarIsPuertos({ commit }, data) {
      commit("setIsPuertos", data);
    },
    AccionCambiarIsDestinos({ commit }, data) {
      commit("setIsDestinos", data);
    },
    AccionCambiarIsContenedores({ commit }, data) {
      commit("setIsContenedores", data);
    },
    AccionCambiarIsPallet({ commit }, data) {
      commit("setIsPallet", data);
    },
    AccionCambiarIsCondiciones({ commit }, data) {
      commit("setIsCondiciones", data);
    },
    AccionCambiarIsNaves({ commit }, data) {
      commit("setIsNaves", data);
    },
    AccionCambiarIsNavieras({ commit }, data) {
      commit("setIsNavieras", data);
    },
    AccionCambiarIsProductos({ commit }, data) {
      commit("setIsProductos", data);
    },
    AccionCambiarIsLimitePlanificaciones({ commit }, data) {
      commit("setIsLimitePlanificaciones", data);
    },
    AccionCambiarIsTemporadas({ commit }, data) {
      commit("setIsTemporadas", data);
    },
    AccionCambiarIsEmbarcador({ commit }, data) {
      commit("setIsEmbarcador", data);
    },
  },
};
